import React, { FC, useEffect, useState } from 'react';

const DELAY = 30;

type TypewriterProps = {
  text: string;
  onComplete?: () => void;
};

/**
 * Components that creates typing effect for a given text
 */
export const Typewriter: FC<TypewriterProps> = ({ text, onComplete }) => {
  const [inputText, setInputText] = useState<string>();
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setInputText(text);
  }, [text]);

  useEffect(() => {
    setCurrentText('');
    setCurrentIndex(0);
  }, [inputText]);

  useEffect(() => {
    let timeout;

    if (currentIndex < text.length) {
      timeout = setTimeout(() => {
        setCurrentText((prevText) => prevText + text[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, DELAY);
    } else {
      onComplete?.();
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [currentIndex, text, onComplete]);

  return <span>{currentText}</span>;
};

export default Typewriter;
